import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import useGlobalStore from 'hooks/useGlobalStore';

/**
 * Tracks the previous pathname and updates lastPath in the global store.
 * Used to preserve navigation history for filter reset logic and anything else that needs to know the previous path.
 */
export default function useLastPathTracking() {
    const location = useLocation();
    const { lastPath } = useGlobalStore();
    const previousPathnameRef = useRef(null);

    useLayoutEffect(() => {
        const currentPath = location.pathname;
        const previousPath = previousPathnameRef.current;

        // If we have a previous path and it's different from current, preserve it
        if (previousPath !== null && previousPath !== currentPath) {
            // Update lastPath to the previous path (preserve it)
            lastPath.current = previousPath;
        }

        // Always update the ref to the current path for the next change
        // This happens after we've preserved the previous path
        previousPathnameRef.current = currentPath;
    }, [location.pathname]);
}
